type Props = {
  visible: boolean;
  onClick: () => void;
};

export default function Backdrop({visible, onClick}: Props) {
  const theme = visible ? null : 'hidden';

  return (
    <div
      className={`fixed inset-0 z-10 bg-black/50 backdrop-blur-xs ${theme}`}
      onClick={onClick}
    />
  );
}
